// extracted by mini-css-extract-plugin
export default {"main":"MainChat_main__OTMF4"};